export default "__VITE_ASSET__P684sm3j__"